import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpCommunity'

export const getReviewDistributions = params => Http.get(`/review-distributions/fetch${serialize(params)}`)

export const getReviewDistributionCounts = () => Http.get('/review-distributions/counts')

export const updateSteamStatus = (id, status) => Http.patch(`/review-distributions/${id}/steam-status`, { status })

export const bulkMarkSteamPosted = ids => Http.post('/review-distributions/bulk-mark-steam-posted', { ids })

export const bulkUpdateSteamStatus = (ids, status) =>
	Http.post('/review-distributions/bulk-steam-status', { ids, status })

export const retryOpenCritic = id => Http.post(`/review-distributions/${id}/retry-opencritic`)

export const updateMetacriticStatus = (id, status, note) =>
	Http.patch(`/review-distributions/${id}/metacritic-status`, { status, note })
